jQuery(document).ready(function() {
  google.maps.event.addDomListener(window, 'load', initMap);

  function initMap() {
    /* setup map */

    let position = {
      lat: 40.758549,
      lng: -82.515472,
    }

    let map = new google.maps.Map(document.getElementById('map'), {
      center: position,
      zoom: 7,
    });

    let iconBase = '/app/themes/summitacademies/dist/images/';

    let icons = {
      'school': iconBase+'mapmarker14.png',
      'crc': iconBase+'summit-crc.png',
    };

    let infowindow = new google.maps.InfoWindow({
      content: ''
    });

    /* add listeneer to close info window when click on map */
    map.addListener('click', function() {
      infowindow.close()
    });

    let markers = [];

    /* loop through map points */
    for (let i = 0; i < mapPoints.length; i++) {

      let position = {
        lat: parseFloat(mapPoints[i]['lat']),
        lng: parseFloat(mapPoints[i]['lng']),
      }

      let marker = new google.maps.Marker({
        summitId: i,
        position: position,
        map: map,
        icon: icons[mapPoints[i]['type']]
      });

      let content = `
      <h4 class="mb-0 map-info__h4"><a href="${mapPoints[i]['path']}">${mapPoints[i]['name']}</a></h4>
      <p>${mapPoints[i]['address']}<br/>
        <strong>Grades:</strong> ${mapPoints[i]['grades']} | <strong>Phone:</strong> ${mapPoints[i]['phone']} | <strong>Fax:</strong> ${mapPoints[i]['fax']}
      </p>
      <p><a href="${mapPoints[i]['path']}" class="btn btn-map-info btn-sm btn-primary text-uppercase">More Info</a> <a href="https://www.google.com/maps/dir//${mapPoints[i]['address']}/" class="btn btn-map-info btn-sm btn-secondary text-uppercase">Get Directions</a>
      </p>`;

      marker.addListener('click', function() {
        infowindow.open(map, marker);
        infowindow.setContent(
          content
        )
      });

      jQuery(".map-search-list").append("<li id='summitId-"+i+"' class='list-group-item'>"+content+"</li>");

      markers.push(marker)
    }

    jQuery(".map-search-list-loader").remove();

    /* find lat/long of zip code */
    jQuery(".map-search").on("submit", function(e) {
      e.preventDefault();
      let geocoder = new google.maps.Geocoder();
      let address = document.getElementById("zipSearch").value;

      let sortedList = [];

      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK)
        {
          let nearbyLocations = 0; // start with 0 locations found
          let bounds = new google.maps.LatLngBounds();

          for (let i = 0; i < markers.length; i++) { // loop markers array
            let schoolLocation = new google.maps.LatLng(markers[i].position.lat(), markers[i].position.lng());
            let center = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            let distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(schoolLocation, center);


            if(distanceInMeters < 96560.6) { // less than 60 miles
              markers[i].setMap(map);
              $listItem = jQuery("#summitId-"+markers[i]['summitId']);
              $listItem.find(".map-distance").remove();
              $listItem.show();

              let distanceInMiles = (distanceInMeters/1609.34).toFixed(2);
              $listItem.attr("data-distance", distanceInMiles);
              $listItem.find("h4").append("<span class='map-distance'><br/> Distance: "+distanceInMiles+" miles</span>");

              let extendedBounds = new google.maps.LatLng(markers[i].position.lat(), markers[i].position.lng());
              bounds.extend(extendedBounds);
              nearbyLocations++;
            } else { // remove markers that are more than 60 miles
              jQuery("#summitId-"+markers[i]['summitId']).hide();
              markers[i].setMap(null);
            }
          }

          if(nearbyLocations > 0) { // some locations found

            $(".map-search-list li").sort(sort_li).appendTo('.map-search-list');
            function sort_li(a, b) {
              if(!$(a).attr('style')) {
                return (parseFloat($(b).attr('data-distance'))) < (parseFloat($(a).attr('data-distance'))) ? 1 : -1;
              }
            }

            jQuery(".list-group-item--no-results").remove();
            map.fitBounds(bounds);
          } else { // no locations found
            jQuery(".map-search-list").append("<li class='list-group-item list-group-item--no-results'>No results found. Please try again.</li>");
          }
        }
      });
    });


  }


});



// WEBPACK FOOTER //
// ./scripts/maps.js